import { OriginEntity } from '../entities/origin-entity';

export default class State {
  loaded = false;

  items: Array<OriginEntity> = [];
}
